import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import { useBrPageContext } from '../../../context/context.js';
import '@bloomreach/react-sdk';
import '../../../context/configuration.js';
import CmsAccordion from '../../Accordion/Accordion.js';
import CmsArticleCollection from '../../ArticleCollection/ArticleCollection.js';
import CmsBanner from '../../Banner/Banner.js';
import CmsBannerCollection from '../../BannerCollection/BannerCollection.js';
import CmsCarousel from '../../Carousel/Carousel.js';
import CmsCountdownTimerDocument from '../../CountdownTimer/CountdownTimerDocument.js';
import CmsIframe from '../../Iframe/Iframe.js';
import CmsLinkList from '../../LinkList/LinkList.js';
import CmsRecommendedProducts from '../../RecommendedProducts/RecommendedProducts.js';
import CmsRichTextDocument from '../../RichText/RichTextDocument.js';
import CmsVideo from '../../Video/Video.js';
import CmsWidget from '../../Widget/Widget.js';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const blockMap = {
    accordion: CmsAccordion,
    articleCollection: CmsArticleCollection,
    banner: CmsBanner,
    bannerCollection: CmsBannerCollection,
    carousel: CmsCarousel,
    countdown: CmsCountdownTimerDocument,
    iFrame: CmsIframe,
    linkList: CmsLinkList,
    recommendedProducts: CmsRecommendedProducts,
    video: CmsVideo,
    widget: CmsWidget,
    richText: CmsRichTextDocument
};
const ContentBlock = ({ contentBlock  })=>{
    const page = useBrPageContext();
    const component = mapBlockToComponent(contentBlock);
    const BlockComponent = getComponentForBlockType(contentBlock.type);
    const headingLevel = contentBlock.type === 'accordion' ? 'h2' : undefined;
    return BlockComponent && component ? /*#__PURE__*/ React.createElement(BlockComponent, {
        component: component,
        page: page,
        headingLevel: headingLevel
    }) : null;
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function getComponentForBlockType(type) {
    const Component = blockMap[type];
    if (!Component) {
        console.log(`Missing Component for content block type: ${type}`);
        return;
    }
    return Component;
}
/**
 * The "ContentBlocks" implementation in the CMS used on content pages
 * is a custom modification of Bloomreach. Hence we need to map the content
 * object we receive to something for our CMS containers to a representation of
 * the "component" object they receive from the BR SDK by default.
 */ function mapBlockToComponent({ anchorId , coverImage , document , expandedByDefault , recommendedProducts , html , template , videoUrl , visibility , source , showCountdown , endDate , countdownText , layout , height , scrolling , title , imageWidth , imageAlignment , bannerWidth , bannerHeight , textColor , backgroundColor , mobilePresentation , buttonText , buttonStyling , newWindow , iconImage , url , description  }) {
    const parsedDocument = Array.isArray(document) ? {
        pageable: {
            items: document
        }
    } : {
        document
    };
    function getModels() {
        return swcHelpers.objectSpread({}, parsedDocument, {
            coverImage,
            html,
            visibility,
            iframe: {
                source,
                height,
                scrolling,
                title
            }
        });
    }
    function getParameters() {
        return {
            anchorId,
            template,
            videoUrl,
            expandedByDefault,
            recommendedProducts,
            imageWidth,
            imageAlignment,
            bannerWidth,
            bannerHeight,
            showCountdown,
            endDate,
            countdownText,
            layout,
            textColor,
            backgroundColor,
            mobilePresentation,
            buttonText,
            buttonStyling,
            newWindow,
            iconImage,
            url,
            description
        };
    }
    return {
        getModels,
        getParameters
    };
}

export { ContentBlock, blockMap, ContentBlock as default };
//# sourceMappingURL=ContentBlock.js.map
